import { MultiSelectInput, type MultiSelectInputProps } from '@interxfi/design-system/components/input/multi-select-input/multi-select-input';
import { type FixedOptionInputBaseProps, useFixedOptionInputOptions } from './shared';

export type FixedOptionMultiSelectInputProps<TValue extends string = string> = Omit<MultiSelectInputProps, 'options'> &
  FixedOptionInputBaseProps<TValue>;

export function FixedOptionMultiSelectInput<TValue extends string = string>({
  filter,
  i18nNamespace,
  i18nPrefix,
  i18nValueName,
  optionModifier,
  optionValues,
  sortByLabel,
  ...rest
}: FixedOptionMultiSelectInputProps<TValue>) {
  const options = useFixedOptionInputOptions({
    filter,
    i18nNamespace,
    i18nPrefix,
    i18nValueName,
    optionModifier,
    optionValues,
    sortByLabel,
  });

  return <MultiSelectInput options={options} {...rest} />;
}
